import { PaginationData, post, postData, ResultData } from '../../util/Api';
import { Invoice } from '../InvoiceModel';
import { User } from '../UserModel';
import { DailyReport } from './DailyReportModel';
import { Stamp } from './StampModel';

export interface DailyReportComment {
  id: number | null;
  created_at: Date | null;
  updated_at: Date | null;
  deleted_at: Date | null;
  user_id: number;
  fk_daily_reports_id: number;
  comment: string;
  user: User | null;
  stamp_id?: number;
  stamp?: Stamp;
  is_read?: boolean;
}

// DailyReport class implementing the interface
export class DailyReportCommentModel implements DailyReportComment {
  id: number | null;
  created_at: Date | null;
  updated_at: Date | null;
  deleted_at: Date | null;
  user_id: number;
  fk_daily_reports_id: number;
  stamp_id?: number | undefined;
  comment: string;
  user: User | null;
  stamp: Stamp | undefined;
  is_read?: boolean;
  static id: any;

  constructor(data: DailyReportComment) {
    this.id = data?.id;
    this.created_at = data?.created_at;
    this.updated_at = data?.updated_at;
    this.deleted_at = data?.deleted_at;
    this.user_id = data?.user_id;
    this.fk_daily_reports_id = data?.fk_daily_reports_id;
    this.comment = data.comment;
    this.user = data?.user;
    this.stamp_id = data?.stamp_id;
    this.stamp = data?.stamp;
    this.is_read = data?.is_read;
  }

  /**
   * コメントを既読にする
   * @param dailyReportComment 対象の日報コメント
   * @returns Promise<void>
   */
  static async markAsRead(dailyReportComment: DailyReportComment): Promise<void> {
    if (!dailyReportComment.id) {
      throw new Error('日報コメントが指定されていません。');
    }

    await postData(`/daily_reports/comments/${dailyReportComment.id}/mark-as-read`);
  }

  /**
   * コメントを削除する
   */
  static async delete(dailyReportComment: DailyReportComment): Promise<void> {
    if (!dailyReportComment.id) {
      throw new Error('日報コメントが指定されていません。');
    }
    await postData(`/daily_reports/comments/${dailyReportComment.id}/delete`);
  }

  async save(): Promise<ResultData<DailyReportComment>> {
    if (this.fk_daily_reports_id == 0) {
      throw new Error('登録先の日報が指定されていません。');
    }
    const uri = `/daily_reports/comments/save`;
    let response = await postData(uri, this);

    return response.data;
  }
}
